import { action } from 'satcheljs';

const defaultExport: () => {} = action('openInClientStore');
export default defaultExport;
